<a *ngIf="isVisible" href="{{defaultOfferLink}}" target="_blank" (click)="bannerClick()">
  <div class="banner-container">
    <div class="plus"><span>Plus</span></div>
    <div class="message">Enjoying this <span class="free-plus">Free Plus Video</span>? <span [innerHtml]="messageContent | trustHtml"></span></div>
    <div *ngIf="!this.isVodPremium" class="dismiss" (click)="dismiss($event)">X</div>
  </div>
</a>
